import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { downloadReferralPDF } from '../../../utils/pdfGenerator';

const ActionPanel = ({ pdfData, practitionerData, onEdit, onPrint, onSubmit, isLoading = false }) => {
  const handleDownload = () => {
    // Generate filename from patient data
    const patientInitials = pdfData?.patientInfo?.initials?.replace(/\./g, '') || 'Patient';
    const referenceNumber = `REF-${Date.now()?.toString()?.slice(-8)}`;
    
    // Generate and download PDF with practitioner data
    downloadReferralPDF(pdfData, patientInitials, referenceNumber, practitionerData);
  };

  return (
    <div className="flex flex-col gap-6 p-6 bg-[rgba(22,22,22,0.4)] backdrop-blur-[40px] rounded-2xl border border-white/8 shadow-[0_8px_32px_rgba(0,0,0,0.5),0_0_0_1px_rgba(255,255,255,0.03)_inset]">
      {/* Panel Header */}
      <div className="flex items-center gap-3 pb-4 border-b border-white/6">
        <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-primary/10 border border-primary/20">
          <Icon name="FileCheck" size={20} className="text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Actions du document</h3>
      </div>

      {/* Action Buttons Group */}
      <div className="flex flex-col gap-3">
        <p className="text-sm font-medium text-muted-foreground mb-1">Modifier et exporter</p>
        
        <Button
          variant="outline"
          size="md"
          fullWidth
          iconName="Edit"
          iconPosition="left"
          onClick={onEdit}
          className="justify-center gap-3 h-12 text-sm font-medium hover:bg-primary/15 hover:border-primary/50 hover:text-primary transition-all duration-300 ease-in-out hover:shadow-[0_0_20px_rgba(74,144,226,0.2)]"
        >
          <span>Modifier le formulaire</span>
        </Button>

        <Button
          variant="outline"
          size="md"
          fullWidth
          iconName="Printer"
          iconPosition="left"
          onClick={onPrint}
          className="justify-center gap-3 h-12 text-sm font-medium hover:bg-blue-500/15 hover:border-blue-400/50 hover:text-blue-400 transition-all duration-300 ease-in-out hover:shadow-[0_0_20px_rgba(96,165,250,0.2)]"
        >
          <span>Imprimer le document</span>
        </Button>

        <Button
          variant="outline"
          size="md"
          fullWidth
          iconName="Download"
          iconPosition="left"
          onClick={handleDownload}
          className="justify-center gap-3 h-12 text-sm font-medium hover:bg-green-500/15 hover:border-green-400/50 hover:text-green-400 transition-all duration-300 ease-in-out hover:shadow-[0_0_20px_rgba(74,222,128,0.2)]"
        >
          <span>Télécharger le PDF</span>
        </Button>
      </div>

      {/* Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent my-2"></div>

      {/* Primary Action */}
      <div className="flex flex-col gap-3">
        <p className="text-sm font-medium text-muted-foreground mb-1">Finalisation</p>
        
        <Button
          variant="default"
          size="lg"
          fullWidth
          iconName={isLoading ? null : "Send"}
          iconPosition="left"
          onClick={onSubmit}
          disabled={isLoading}
          className="h-14 text-base font-semibold bg-primary hover:bg-blue-600 shadow-[0_4px_16px_rgba(74,144,226,0.3)] hover:shadow-[0_6px_24px_rgba(59,130,246,0.5)] transition-all duration-300 hover:scale-[1.02] disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:scale-100"
        >
          {isLoading ? (
            <>
              <svg className="animate-spin h-5 w-5 mr-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span className="flex-1">Envoi en cours...</span>
            </>
          ) : (
            <span className="flex-1">Finaliser l'adressage</span>
          )}
        </Button>
        
        <p className="text-xs text-muted-foreground/70 text-center leading-relaxed">
          Le document sera envoyé au praticien après validation
        </p>
      </div>
    </div>
  );
};

export default ActionPanel;